import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import MatchBracketStore from './store';
import styles from './index.less';

const classNames = (...names) => names.filter(Boolean).join(' ');

const Participant = ({ participant, className, lineClassName }) => (
  <p
    className={classNames(
      styles.participant,
      className,
      participant.isWinner && styles.winner,
      participant.camp === 'SONG' && styles.songWinner,
      participant.camp === 'JIN' && styles.jinWinner
    )}
    title={participant.fullName !== participant.name ? participant.fullName : undefined}
  >
    <span className={styles.participantText}>{participant.name}</span>
    {lineClassName ? (
      <span className={classNames(styles.winnerLine, lineClassName, participant.camp === 'JIN' && styles.jinWinnerLine)} aria-hidden="true" />
    ) : null}
  </p>
);

const Side = ({ side, right }) => {
  const firstItemClasses = [styles.firstItemOne, styles.firstItemTwo, styles.firstItemThree, styles.firstItemFour];
  const firstLineClasses = [styles.lineDown, styles.lineUp, styles.lineDown, styles.lineUp];

  return (
    <div className={classNames(styles.side, right && styles.rightSide)}>
      <div className={styles.firstRound}>
        {side.firstRound.map((participant, index) => (
          <Participant participant={participant} className={firstItemClasses[index]} lineClassName={firstLineClasses[index]} key={participant.id} />
        ))}
      </div>
      <div className={styles.secondRound}>
        {side.secondRound.map((participant, index) => (
          <Participant
            participant={participant}
            className={index === 0 ? styles.secondItemOne : styles.secondItemTwo}
            lineClassName={index === 0 ? styles.secondLineOne : styles.secondLineTwo}
            key={participant.id}
          />
        ))}
      </div>
      <div className={styles.finalRound}>
        <Participant participant={side.finalist} />
      </div>
    </div>
  );
};

const BracketGroup = ({ group }) => (
  <div className={styles.bracketGroup}>
    <Side side={group.left} />
    <Side side={group.right} right />
  </div>
);

const BracketStage = ({ stage }) => (
  <div
    className={classNames(styles.stage, stage.layoutType === 'BRACKET_32_TO_8' ? styles.stage32 : styles.stageChampion)}
    id={`match-stage-${stage.id}`}
    role="tabpanel"
    aria-label={stage.title}
  >
    {stage.layoutType === 'BRACKET_8_TO_CHAMPION' ? (
      <div className={styles.champion} title={stage.championFullName !== stage.champion ? stage.championFullName : undefined}>
        {stage.champion}
      </div>
    ) : null}
    {stage.groups.map(group => <BracketGroup group={group} key={group.id} />)}
  </div>
);

const MatchBracket = ({ matchConfigUrl, store }) => {
  store.use();
  React.useEffect(
    () => {
      store.setMatchConfigUrl(matchConfigUrl);
    },
    [matchConfigUrl]
  );

  const stages = store.stages;
  const activeStage = store.activeStage;

  return (
    <section className={styles.root} aria-label="对阵详情" data-load-status={store.loadStatus}>
      <div className={styles.legend} aria-hidden="true">
        <span className={styles.songIcon}>宋</span>
        <span className={styles.jinIcon}>金</span>
      </div>
      {stages.length ? (
        <div className={styles.stageTabs} role="tablist" aria-label="对阵赛段">
          {stages.map(stage => {
            const isActive = stage.id === store.activeStageId;
            return (
              <button
                type="button"
                className={classNames(styles.stageTab, isActive && styles.activeStageTab)}
                role="tab"
                aria-selected={isActive}
                aria-controls={`match-stage-${stage.id}`}
                data-stage-id={stage.id}
                key={stage.id}
                onClick={() => store.setActiveStage(stage.id)}
              >
                {stage.title}
              </button>
            );
          })}
        </div>
      ) : null}
      {store.loading && !activeStage ? <div className={styles.status}>对阵信息加载中...</div> : null}
      {!matchConfigUrl && !store.loading && !activeStage ? <div className={styles.status}>对阵信息暂未配置</div> : null}
      {activeStage ? <BracketStage stage={activeStage} /> : null}
    </section>
  );
};

MatchBracket.defaultProps = {
  matchConfigUrl: ''
};

export default wrapStore(MatchBracket, MatchBracketStore);
